import { render, staticRenderFns } from "./FriendlyLinks.vue?vue&type=template&id=62c0355a&scoped=true&"
import script from "./FriendlyLinks.vue?vue&type=script&lang=js&"
export * from "./FriendlyLinks.vue?vue&type=script&lang=js&"
import style0 from "./FriendlyLinks.vue?vue&type=style&index=0&id=62c0355a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c0355a",
  null
  
)

export default component.exports